import BodyText from 'LuxKit/Typography/BodyText'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import CalendarPickerRecommendations from './CalendarPickerRecommendations'
import { getRecommendationsTitle } from './utils/recommendationsTitle'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { useCalendarRecommendationsView } from '../CalendarRecommendationsViewContext'

interface Props {
  duration: number
  offer: App.Offer
  rooms: Array<App.Occupants>
}

function CalendarPickerRecommendationsSidebar({
  offer,
  duration,
  rooms,
}: Props) {
  const intl = useIntl()
  const { view, hasRenderableRecommendations } = useCalendarRecommendationsView()
  const checkIn = view?.checkIn
  const monthIndex = view?.monthIndex

  const title = useMemo(() => getRecommendationsTitle({
    checkIn,
    monthIndex,
    duration,
    intl,
  }).title, [checkIn, duration, monthIndex, intl])

  return <VerticalSpacer gap={24}>
    {hasRenderableRecommendations && <BodyText variant="large" align="center" colour="light-foreground-alt">{title}</BodyText>}
    <CalendarPickerRecommendations
      offerId={offer.id}
      offerType={offer.type}
      rooms={rooms}
      seedOffer={offer}
      duration={duration}
      checkIn={checkIn}
      monthIndex={monthIndex}
    />
  </VerticalSpacer>
}

export default withOfferPageAndReduxState((state) => ({
  offer: state.offer,
  duration: state.duration,
  rooms: state.rooms,
}), CalendarPickerRecommendationsSidebar)
